import { IOnboardingTourStep } from "front";

/**
 * The Contacts Pro guided tour, one step per main feature of the contact view. The engine (card,
 * spotlight, when it opens) is the shared `OnboardingTour` of `front`; texts are in
 * `translations.ts` under `OnboardingTour:<id>:*`. Steps whose targets are not on screen are
 * dropped when the tour starts (no A–Z picker on an empty list, no banner for a premium user).
 */
export enum OnboardingTourStepId {
  Welcome = "Welcome",
  NewContact = "NewContact",
  Contacts = "Contacts",
  Alphabet = "Alphabet",
  Search = "Search",
  DisplayMode = "DisplayMode",
  Settings = "Settings",
  Premium = "Premium",
  Finish = "Finish",
}

/** Storage namespace of the "seen" flag. */
export const ONBOARDING_TOUR_APP_KEY = "contactPro";

/** data-testid of the main action, the target of the final call to action. */
export const ONBOARDING_TOUR_CTA_TARGET = "navbar-new-contact-btn";

export const ONBOARDING_TOUR_STEPS: IOnboardingTourStep[] = [
  { id: OnboardingTourStepId.Welcome, targets: [], glyph: "👋", standalone: true },
  { id: OnboardingTourStepId.NewContact, targets: ["navbar-new-btn"], glyph: "➕" },
  { id: OnboardingTourStepId.Contacts, targets: ["contactList-users-container"], glyph: "📇" },
  { id: OnboardingTourStepId.Alphabet, targets: ["alphabetPicker-container"], glyph: "🔤" },
  { id: OnboardingTourStepId.Search, targets: ["navbar-search"], glyph: "🔎" },
  { id: OnboardingTourStepId.DisplayMode, targets: ["navbar-display-mode-btn"], glyph: "👁️" },
  { id: OnboardingTourStepId.Settings, targets: ["navbar-more-options-btn"], glyph: "⚙️" },
  { id: OnboardingTourStepId.Premium, targets: ["premium-banner"], glyph: "👑", accent: "#8A6A00" },
  { id: OnboardingTourStepId.Finish, targets: [], glyph: "🚀", standalone: true, showsCta: true },
];
